
import { Component, Vue } from 'vue-property-decorator';
import { api } from '@/api';
import { appName } from '@/env';
import { readLoginError } from '@/store/main/getters';
import { dispatchLogIn } from '@/store/main/actions';

@Component
export default class Login extends Vue {
  public email: string = '';
  public password: string = '';
  public appName = appName;

  public get loginError() {
    return readLoginError(this.$store);
  }

  public showInfo() {
    this.$router.push({name: 'guidance'});
  }

  public submit() {
    dispatchLogIn(this.$store, {username: this.email, password: this.password});
  }
  public createUser() {
    this.$router.push('/create-user-email');
  }
  public resetPassword() {
    this.$router.push({name: "recover-password"})
  }
}
